import React, { useCallback, useEffect, useState, Component } from 'react';
import { ProspectCoverSlide } from '../components/slides/prospect/ProspectCoverSlide';
import { ProspectProblemSlide } from '../components/slides/prospect/ProspectProblemSlide';
import { ProspectDemoSlide } from '../components/slides/prospect/ProspectDemoSlide';
import { ProspectFeaturesSlide } from '../components/slides/prospect/ProspectFeaturesSlide';
import { ProspectUseCasesSlide } from '../components/slides/prospect/ProspectUseCasesSlide';
import { ProspectPricingSlide } from '../components/slides/prospect/ProspectPricingSlide';
import { ProspectTestimonialsSlide } from '../components/slides/prospect/ProspectTestimonialsSlide';
import { ProspectNextStepsSlide } from '../components/slides/prospect/ProspectNextStepsSlide';
export function ProspectPresentation() {
  const [currentSlide, setCurrentSlide] = useState(1);
  const slides = [ProspectCoverSlide, ProspectProblemSlide, ProspectDemoSlide, ProspectFeaturesSlide, ProspectUseCasesSlide, ProspectPricingSlide, ProspectTestimonialsSlide, ProspectNextStepsSlide];
  const totalSlides = slides.length;
  const nextSlide = useCallback(() => {
    if (currentSlide < totalSlides) {
      setCurrentSlide(prev => prev + 1);
    }
  }, [currentSlide, totalSlides]);
  const prevSlide = useCallback(() => {
    if (currentSlide > 1) {
      setCurrentSlide(prev => prev - 1);
    }
  }, [currentSlide]);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === 'Space') {
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        prevSlide();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nextSlide, prevSlide]);
  const CurrentSlideComponent = slides[currentSlide - 1];
  return <div className="w-full h-screen bg-black" data-id="element-438">
      <CurrentSlideComponent isActive={true} currentSlide={currentSlide} totalSlides={totalSlides} onNext={nextSlide} onPrev={prevSlide} data-id="element-439" />
    </div>;
}